@use '../functions/string';
@use '../variables/appearance';

// stylelint-disable selector-pseudo-class-no-unknown, property-no-unknown -- :export is the CSS modules syntax
:export {
  colorThemeList: #{appearance.$color-theme-list};
  densityList: #{appearance.$density-list};
  defaultColorTheme: appearance.$default-color-theme;
  defaultDensity: appearance.$default-density;

  @each $color-theme, $frame-color-theme in appearance.$frame-color-theme-map {
    #{string.camel-case('frame-' + $color-theme)}: $frame-color-theme;
  }
}
